import React, { Suspense } from 'react';
import { useGetActiveCompanyName } from 'src/hooks/useGetActiveCompanyName';
import { useFrontendAnalytics } from 'src/hooks/useFrontendAnalytics';
import { CustomLoadingScreen } from 'src/pages/User';
import { FrontendAnalyticsProps } from 'src/frontend-common/dto/Interfaces/FrontendAnalytics/IFrontendAnalytics';
import ErrorBoundary from 'src/frontend-common/components/MicroServiceErrorBundary';

const FrontendAnalyticsWrapper: React.FC<FrontendAnalyticsProps & { customFallBack?: React.JSX.Element }> = (props) => {
  const { product, customFallBack = <CustomLoadingScreen variant="circle" /> } = props;

  const _activeCompany = useGetActiveCompanyName();
  const FrontendAnalytics = useFrontendAnalytics();

  const commonProps = {
    product,
    activeCompany: _activeCompany,
  };

  return (
    <ErrorBoundary>
      <Suspense fallback={customFallBack}>
        <FrontendAnalytics
          {...commonProps}
          filters={props.filters}
          analyticsFilters={props.analyticsFilters}
          bestIdentities={props.bestIdentities}
          worstIdentities={props.worstIdentities}
        />
      </Suspense>
    </ErrorBoundary>
  );
};

export default FrontendAnalyticsWrapper;
